export default {
  title: {
    en: 'Your payment could not be processed',
  },
  titlePrepaid: {
    en: 'You’re trying to pay with a prepaid card',
  },
  textPrepaid: {
    en: `
      Unfortunately, our system has difficulties accepting prepaid cards for monthly subscriptions.
    `,
  },
  textNotEnougth: {
    en: `
      Unfortunately, our system indicates that the card you tried does not have
      enough funds to cover this transaction.
  `,
  },
  note: {
    en: `
      If you try PayPal or another card instead, we will automatically apply
      a discount of $5 OFF YOUR FIRST SCENT as a token of appreciation.
  `,
  },
  orderButton: {
    en: 'Use another card for $5 off',
  },
  orderButtonPrepaid: {
    en: 'Try a new card',
  },
  proceedButton: {
    en: 'Proceed with a prepaid card',
  },
}
